import React, { useEffect, useState } from "react";
import "./GroupLoansMemberBalances.scss";
import { useSelector, useDispatch } from "react-redux";
import { Box, Button, Menu, MenuItem, Typography, Dialog, DialogActions, DialogContent, DialogTitle, IconButton } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import GroupLoansTable from "../../../components/GroupLoansTable/GroupLoansTable";
import GroupLoansMemberContributions from "../GroupLoansMemberContributions/GroupLoansMemberContributions";
import CloseIcon from "@mui/icons-material/Close";
import BaseDrawer from "../../../components/UI/BaseDrawer/BaseDrawer";

const GroupLoansMemberBalances = ({ selectedLoan, setMembersListView, selectedMemberName }) => {
    const [loanBalances, setLoanBalances] = useState([]);
    const [loading, setLoading] = useState(true);
    const [anchorEl, setAnchorEl] = useState(null);
    const [selectedBalance, setSelectedBalance] = useState(null);
    const [balancesListView, setBalancesListView] = useState(null);
    const [openDetailsDialog, setOpenDetailsDialog] = useState(false);
    const [openDetailsDrawer, setOpenDetailsDrawer] = useState(false);
    
    useEffect(()=>{
        getMemberBalances();
    },[]);

    const columns = [
        {
            label: 'Account Id',
            getValue: (row) => row?.vloangroupmemberuserpi?.acctID ?? ''
        },
        {
            label: 'Product Code',
            getValue: (row) => row?.vloangroupmemberuserpi?.currCode ?? ''
        },
        {
            label: 'Balance',
            getValue: (row) => row?.vloangroupmemberuserpi?.balance ?? '',
            align: 'right',
            amount: true
        },
        {
            label: 'Unavailable Balance',
            getValue: (row) => row?.vloangroupmemberuserpi?.unavailableBalance ?? '',
            align: 'right',
            amount: true
        },
        {
            label: 'PI Id',
            getValue: (row) => row?.vloangroupmemberuserpi?.piid ?? ''
        },
        {
            label: 'PI Id Name',
            getValue: (row) => row?.vloangroupmemberuserpi?.piidname ?? ''
        }
    ];

    const getMemberBalances = async() => {
        try {
            // const response = await commonRunQuery(287, selectedLoan?.loangroups?.groupid ? selectedLoan?.loangroups?.groupid : selectedLoan?.lgm?.groupid);
            const response = await commonRunQuery(289, 9961);
            if ( response?.data?.header?.callStatus === "1" && response?.data?.header?.reccount !== "0" ) {
                const groupsArray = Array.isArray(response?.data?.body?.record)
                        ? response?.data?.body?.record
                        : [response?.data?.body?.record];
      
                setLoanBalances(groupsArray);
              console.log("getMemberBalances_response==========",groupsArray);
            } else {
                setLoanBalances([]);
            }
      
        } catch (error) {
            console.log("getMemberBalances_error==========",error);
        } finally {
            setLoading(false)
        }
    }

    const handleMenuOpen = (event, loan) => {
        console.log("GroupLoansMemberBalances_handleMenuOpen------------",loan)
        setAnchorEl(event.currentTarget);
        setSelectedBalance(loan);
    };

    const handleMenuClose = () => {
        console.log("handleMenuClose------------")
        setAnchorEl(null);
    };

    const formatedRows = (row) => columns.map((column) => column.getValue(row));

    return (
        <Box>
            {
                balancesListView == null && 
                <Box className="d-flex justify-content-between">
                    <Typography
                    sx={{
                        fontFamily: "'Nunito'",
                        fontStyle: "normal",
                        fontWeight: 500,
                        fontSize: "21.4825px",
                        color: "#3A3A3A",
                    }}
                    className=""
                    >
                        Member Balances - {selectedMemberName}
                    </Typography>

                    <Button
                        className="fs-size-12 paiy-blue text-white"
                        variant="contained"
                        color="primary"
                        onClick={() => {
                            setMembersListView(null);
                        }}
                    >
                        Return
                    </Button>
                </Box>
            }

            {
                balancesListView == null && 
                <Box>
                    <GroupLoansTable
                        data={loanBalances} 
                        columns={columns} 
                        title="Member Balances" 
                        formatRow={formatedRows} 
                        viewMenu={true}
                        handleMenuOpen={handleMenuOpen}
                        downloads={false}
                        // author={`${user?.user?.firstName} ${user?.user?.lastName}`} 
                    />
                </Box>
            }

            {
                balancesListView == "memberContributions" && <GroupLoansMemberContributions selectedBalance={selectedBalance} setBalancesListView={setBalancesListView} selectedMemberName={selectedMemberName} />
            }

            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleMenuClose}>
                <MenuItem
                    onClick={() => {
                        setBalancesListView('memberContributions');
                        handleMenuClose();
                    }}
                >
                    Member Contributions
                </MenuItem>
                <MenuItem
                    onClick={() => {
                        // setOpenDetailsDialog(true);
                        setOpenDetailsDrawer(true);
                        handleMenuClose();
                    }}
                >
                    View Details
                </MenuItem>
            </Menu>

            <BaseDrawer
                open={openDetailsDrawer}
                handleClose={() => setOpenDetailsDrawer(false)}
                height="70vh"
                className="loanProductInfoDrawer"
                overflow="auto"
            >
                {selectedBalance && (
                    <Box>
                        <Box className="user-accounts-tab">
                            <Box className="balance-container">
                                <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                    {/* Left Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[
                                            { label: "User Id", value: selectedBalance?.vloangroupmemberuserpi?.userid || "N/A" },
                                            { label: "Account Id", value: selectedBalance?.vloangroupmemberuserpi?.acctID || "N/A" },
                                            { label: "Balance", value: selectedBalance?.vloangroupmemberuserpi?.balance || "-" },
                                            { label: "Unavailable Balance", value: selectedBalance?.vloangroupmemberuserpi?.unavailableBalance || "N/A" },
                                            { label: "Currency Code", value: selectedBalance?.vloangroupmemberuserpi?.currCode || "N/A" },
                                        ].map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">{value}</Box>
                                            </Box>
                                        ))}
                                    </Box>

                                    {/* Right Column */}
                                    <Box minWidth="300px" flex={1}>
                                        {[
                                            { label: "Group Id", value: selectedBalance?.vloangroupmemberuserpi?.groupid || "N/A" },
                                            { label: "Control Account", value: selectedBalance?.vloangroupmemberuserpi?.controlaccount || "-" },
                                            { label: "Pi Id", value: selectedBalance?.vloangroupmemberuserpi?.piid || "N/A" },
                                            { label: "Pi Id Name", value: selectedBalance?.vloangroupmemberuserpi?.piidname || "N/A" },
                                            { label: "User Pi", value: selectedBalance?.vloangroupmemberuserpi?.userpi || "N/A" },
                                        ].filter(Boolean).map(({ label, value }, index) => (
                                            <Box className="info-container" key={index}>
                                                <Box className="info-type">{label}:</Box>
                                                <Box className="info-response">{value}</Box>
                                            </Box>
                                        ))}
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </Box>
                )}
            </BaseDrawer>

            {/* <Dialog
                open={openDetailsDialog}
                onClose={() => setOpenDetailsDialog(false)}
                fullWidth
                maxWidth="md"
                className="loans-dialog"
            >
                <DialogTitle>
                    <Box>
                        Member Balance Details
                        <Box sx={{ position: "absolute", top: 8, right: 8, width: 40, height: 40 }}>
                            <IconButton onClick={() => setOpenDetailsDialog(false)} sx={{ zIndex: 1, color: "#6c757d", "&:hover": { color: "#000" } }}>
                                <CloseIcon />
                            </IconButton>
                        </Box>
                    </Box>
                </DialogTitle>
                <DialogContent dividers>
                    {selectedBalance && (
                        <Box>
                            <Box className="user-accounts-tab">
                                <Box className="balance-container">
                                    <Box className="row" display="flex" flexWrap="wrap" gap={4}>
                                        <Box minWidth="300px" flex={1}>
                                            {[
                                                { label: "User Id", value: selectedBalance?.vloangroupmemberuserpi?.userid || "N/A" },
                                                { label: "Account Id", value: selectedBalance?.vloangroupmemberuserpi?.acctID || "N/A" },
                                                { label: "Balance", value: selectedBalance?.vloangroupmemberuserpi?.balance || "-" },
                                                { label: "Unavailable Balance", value: selectedBalance?.vloangroupmemberuserpi?.unavailableBalance || "N/A" },
                                                { label: "Currency Code", value: selectedBalance?.vloangroupmemberuserpi?.currCode || "N/A" },
                                            ].map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value}</Box>
                                                </Box>
                                            ))}
                                        </Box>

                                        <Box minWidth="300px" flex={1}>
                                            {[
                                                { label: "Group Id", value: selectedBalance?.vloangroupmemberuserpi?.groupid || "N/A" },
                                                { label: "Control Account", value: selectedBalance?.vloangroupmemberuserpi?.controlaccount || "-" },
                                                { label: "Pi Id", value: selectedBalance?.vloangroupmemberuserpi?.piid || "N/A" },
                                                { label: "Pi Id Name", value: selectedBalance?.vloangroupmemberuserpi?.piidname || "N/A" },
                                                { label: "User Pi", value: selectedBalance?.vloangroupmemberuserpi?.userpi || "N/A" },
                                            ].filter(Boolean).map(({ label, value }, index) => (
                                                <Box className="info-container" key={index}>
                                                    <Box className="info-type">{label}:</Box>
                                                    <Box className="info-response">{value}</Box>
                                                </Box>
                                            ))}
                                        </Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => setOpenDetailsDialog(false)} color="primary">
                            Close
                        </Button>
                    </DialogActions>
            </Dialog> */}
        </Box>
    )
}

export default GroupLoansMemberBalances;
